export default __webpack_public_path__ + "static/media/aliasIcon.236c28f9.png";